import { createContext, useContext } from 'react'

export type ReportWebsocketState = {
  isGeneratingReport: {
    [reportID: string]: boolean
  }
  updateState: (reportID: string, isGenerating: boolean) => void
}
export const ReportWebsocketContext = createContext<ReportWebsocketState | null>(null)

export function useReportWebsocketContext() {
  const context = useContext(ReportWebsocketContext)
  if (!context) throw new Error('useReportsSocket must be used within a ReportWebsocketContext')
  return context
}
